module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/091-slovakia-1cc1a21fca293e2df41d1d84dc209e10.svg";